import { fetcher } from '@commenda/utils';
import { templateVersionsUrl } from './helpers';

// Terminal, and unrelated to which version is active: the active version cannot be archived, and an
// archived version cannot be un-archived. Idempotent on an already-archived version.
export const archiveDocumentAssemblerTemplateVersion = async (
  templateId: string,
  versionId: string
): Promise<Response> => {
  const res = await fetcher(
    `${templateVersionsUrl(templateId)}/${versionId}/archive`,
    { method: 'POST', body: {} }
  );
  return res;
};
